document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('[data-menu-drawer]');
  const overlay = document.querySelector('[data-menu-overlay]');
  const openButton = document.querySelector('[data-menu-open]');
  const closeButton = document.querySelector('[data-menu-close]');

  if (!drawer || !overlay || !openButton || !closeButton) return;

  const openMenu = () => {
    overlay.hidden = false;
    requestAnimationFrame(() => {
      document.body.classList.add('menu-is-open');
      drawer.setAttribute('aria-hidden', 'false');
      openButton.setAttribute('aria-expanded', 'true');
      closeButton.focus();
    });
  };

  const closeMenu = () => {
    document.body.classList.remove('menu-is-open');
    drawer.setAttribute('aria-hidden', 'true');
    openButton.setAttribute('aria-expanded', 'false');
    window.setTimeout(() => { overlay.hidden = true; }, 250);
    openButton.focus();
  };

  openButton.addEventListener('click', openMenu);
  closeButton.addEventListener('click', closeMenu);
  overlay.addEventListener('click', closeMenu);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && document.body.classList.contains('menu-is-open')) closeMenu();
  });
});
